import { COLOR_PALETTE } from 'constants/ui';

export const warningIconStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  color: COLOR_PALETTE.ORANGE[7],
  cursor: 'help',
};
